import ProductRepository from "./../api/product.js"

class ProductUseCase {
    constructor() {
        /** @type {ProductRepository}*/
        this.api = new ProductRepository()
    }

   async getAll(page = 1, perPage = 100, status = "ACTIVE", orderBy = "priority", priority = "ASC", q = "") {
        const {data, err} = await this.api.getAll(page, perPage, status, orderBy, priority, q)
        if (err && err == "record not found") {
            return {data: null, err: null}
        }
        return {data, err}
    }
}

export default new ProductUseCase()
